module.exports = __webpack_public_path__ + "img/Logo-GrosirOne-2.e46a71de.png";